import { CookieKeys } from "@outschool/data-schemas";
import Cookies from "js-cookie";

export function getReferrerSlugId() {
  const osRef = JSON.parse(Cookies.get(CookieKeys.OsRef) || "{}");
  const { usid } = osRef;
  return Array.isArray(usid) ? usid[0] : usid || null;
}
